<div class="queue" [class.empty]="kingService.queue().length === 0">
  <span class="queue__title">In Queue</span>
  <ul class="queue__list">
    @for (user of kingService.queue(); track $index; let last = $last;) {
    <li class="queue__item" [ngpTooltipTrigger]="tooltip" [ngpTooltipTriggerHideDelay]="0">
      <img
        class="queue__item--img"
        [class.border-transparent]="last"
        [class.border-black]="!last"
        [class.margin-left-negative]="!last"
        [alt]="user.name"
        [src]="user.avatar"
      />
    </li>
    <ng-template #tooltip>
      <div class="tooltip" ngpTooltip>
        <div class="tooltip__user">
          <img
            class="tooltip__user--img"
            [alt]="user.name"
            [src]="user.avatar"
          />
          <p class="tooltip__user--name">
            {{ user.name }}
            <app-cost [gap]="4" [cost]="user.value" [balanceType]="'skins'" />
          </p>
        </div>
        <app-skins-row [skins]="user.skins"></app-skins-row>
      </div>
    </ng-template>
    }
  </ul>
</div>
